import React, { useState } from 'react';
import { Form, Radio, DatePicker, Input, Button, message } from 'antd';
import axios from 'axios';


const { TextArea } = Input;


const PoaObservaciones = ({ oidTarea, onObservacionRegistrada }) => {

    const [form] = Form.useForm();
    const [estado, setEstado] = useState(1); // Estado por defecto

    const handleEstadoChange = (e) => {
        setEstado(e.target.value);
    };



    const onFinish = async (values) => {

        // Preparar los datos para enviar al servidor
        const formData = new FormData();
        formData.append('oid_tarea', oidTarea);
        formData.append('observacion', values.observacion);
        formData.append('fecha', values.fecha.format('YYYY-MM-DD')); // Formato la fecha como string
        formData.append('estado', values.estado);

        try {
            const response = await axios.post('https://bodecom.com/api/registrar-observaciones', formData);

            if (response.status === 200) {
                message.success('Observación registrada correctamente.');
                form.resetFields(); // Limpiar campos del formulario después del envío

                onObservacionRegistrada(oidTarea);

            } else {
                //message.error('Error al registrar observación.');
            }
        } catch (error) {
            console.error('Error al enviar observación:', error);
            //message.error('Error de red al registrar observación');
        }

        return false;
    };

    return (
        <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item
                label="Observación"
                name="observacion"
                rules={[{ required: true, message: 'Por favor ingrese la observación' }]}
            >
                <TextArea rows={4} />
            </Form.Item>

            <Form.Item
                label="Fecha"
                name="fecha"
                rules={[{ required: true, message: 'Por favor seleccione la fecha' }]}
            >
                <DatePicker style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item label="Estado" name="estado">
                <Radio.Group onChange={handleEstadoChange}>
                    <Radio value={1}>Procesada</Radio>
                    <Radio value={2}>Pendiente</Radio>
                    <Radio value={3}>Procesando</Radio>
                </Radio.Group>
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit">
                    Guardar
                </Button>
            </Form.Item>
        </Form>
    );
};

export default PoaObservaciones;
